import styled from 'styled-components';
import { colors, devices } from '../../../../base/styled/variables.styled';
import { typography } from '../../../../base/styled/typography.style';
export const Container = styled.div `
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 24px 48px;
  background-color: ${({ $inverse }) => $inverse ? colors.brand700 : 'transparent'};
`;
export const ContentWrapper = styled.div `
  display: flex;
  flex-direction: column;
  padding-top: 24px;
`;
export const SearchWrapper = styled.div `
  margin-bottom: 24px;
  width: 100%;

  @media ${devices.desktop} {
    width: 710px;
  }

  .ps-search-bar {
    max-width: 100%;
    width: 100%;
  }
`;
export const FilterBlock = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 40px;
  gap: 16px;
  flex-wrap: wrap;

  @media ${devices.mobile} {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;
export const ActiveFiltersContainer = styled.div `
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
  flex: 1;
`;
export const ClearFiltersButton = styled.button.withConfig({
    shouldForwardProp: (prop) => !['$inverse'].includes(prop),
}) `
  background: none;
  border: none;
  cursor: pointer;
  ${typography.body3Highlight}
  color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};
  padding: 4px 8px;
  
  &:hover {
    text-decoration: underline;
  }
`;
export const FilterButtonContainer = styled.div `
  position: relative;
  
  @media ${devices.mobile} {
    width: 100%;
  }
`;
export const FilterDropdown = styled.div.withConfig({
    shouldForwardProp: (prop) => !['$isOpen', '$inverse'].includes(prop),
}) `
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 8px;
  width: 320px;
  background-color: ${({ $inverse }) => $inverse ? colors.neutral800 : colors.neutral000};
  border: 1px solid ${({ $inverse }) => $inverse ? colors.neutral600 : colors.neutral200};
  border-radius: 8px;
  z-index: 10;
  display: ${({ $isOpen }) => $isOpen ? 'block' : 'none'};
  max-height: 400px;
  overflow-y: auto;

  @media ${devices.mobile} {
    width: 100%;
    position: static;
    margin-top: 8px;
  }
`;
export const MidiaCardsGrid = styled.div `
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 32px;
`;
export const PaginationContainer = styled.div `
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: auto;
  margin-bottom: 32px;
`;
//# sourceMappingURL=DigitalMediaList.style.js.map